<template>
  <div class="trust-page white-theme">
    <div class="container">
      <div class="page-header text-center">
        <span class="section-tag">{{ $t('trustSafety.tag') }}</span>
        <h1 class="section-title">{{ $t('trustSafety.title') }}</h1>
        <p class="section-subtitle">{{ $t('trustSafety.subtitle') }}</p>
      </div>
      <div class="trust-badges">
        <div class="trust-badge" v-for="(b, idx) in badges" :key="idx">
          <span class="trust-badge-icon">{{ b.icon }}</span>
          <h3>{{ $t(`trustSafety.badges.${idx}.title`) }}</h3>
          <p>{{ $t(`trustSafety.badges.${idx}.desc`) }}</p>
        </div>
      </div>
      <div class="trust-details">
        <div class="trust-section" v-for="(s, idx) in sections" :key="idx">
          <h2>{{ $t(`trustSafety.sections.${idx}.title`) }}</h2>
          <p v-for="(p, pi) in s.paragraphs" :key="pi">{{ $t(`trustSafety.sections.${idx}.paragraphs.${pi}`) }}</p>
        </div>
      </div>
      <div class="trust-cta text-center" style="margin-top:48px;">
        <h3>{{ $t('trustSafety.ctaTitle') }}</h3>
        <p class="text-muted" style="margin-bottom:16px;">{{ $t('trustSafety.ctaDesc') }}</p>
        <a href="mailto:security@miral.org" class="btn btn-primary">{{ $t('trustSafety.ctaButton') }}</a>
      </div>
      <div class="legal-nav" style="margin-top:32px;">
        <router-link to="/terms" class="btn btn-secondary">{{ $t('trustSafety.navTerms') }}</router-link>
        <router-link to="/privacy" class="btn btn-secondary">{{ $t('trustSafety.navPrivacy') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrustSafety',
  computed: {
    badges() {
      return this.$t('trustSafety.badges')
    },
    sections() {
      return this.$t('trustSafety.sections')
    }
  }
}
</script>

<style scoped>
.trust-page { padding: 48px 0 80px; }
.page-header { margin-bottom: 48px; }
.trust-badges { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; margin-bottom: 64px; }
.trust-badge { background: var(--bg-card); border: 1px solid var(--bg-card-border); border-radius: var(--radius-xl); padding: 32px; text-align: center; }
.trust-badge-icon { font-size: 36px; display: block; margin-bottom: 16px; }
.trust-badge h3 { font-size: 17px; font-weight: 700; margin-bottom: 8px; }
.trust-badge p { font-size: 13px; color: var(--text-muted); line-height: 1.6; }
.trust-details { max-width: 800px; margin: 0 auto; }
.trust-section { margin-bottom: 32px; }
.trust-section h2 { font-size: 20px; font-weight: 700; margin-bottom: 12px; }
.trust-section p { font-size: 15px; color: var(--text-secondary); line-height: 1.8; margin-bottom: 12px; }
.legal-nav { display: flex; gap: 12px; justify-content: center; }
@media (max-width: 768px) { .trust-badges { grid-template-columns: repeat(2, 1fr); } }
</style>
